import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../context/AuthWizardContext';
import MainLayout from '../layouts/MainLayout';
import ErrorLayout from '../layouts/ErrorLayout';
import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';
import Dashboard from 'components/dashboards/default';
import Contacts from 'components/app/support-desk/contacts/Contacts';
import Enterprise from 'components/enterprise';
import SplitLogin from 'components/authentication/split/Login';
import Registration from 'components/authentication/split/Registration';
import ProtectedRoute from './ProtectedRoute';
import Settings from 'components/pages/user/settings/Settings';
import Solutions from 'components/solutions';
import AdminPanel from 'components/admin-panel/AdminPanel';
import ForgetPasswordForm from 'components/authentication/split/ForgetPassword'
import ChangePassword from 'components/pages/user/settings/ChangePassword';
const FalconRoutes = () => {
  const { user } = useAuth();

  return (
    <Routes>
      {!user ? (
        <>
          {/* Giriş yapmamış kullanıcılar için rotalar */}
          <Route path="/authentication/split/login" element={<SplitLogin />} />
          <Route path="/authentication/split/register" element={<Registration />} />
          {/* <Route path="/authentication/split/forget-password" element={<ForgetPasswordForm />} /> */}
          {/* Giriş yapmamış kullanıcıların default olarak login sayfasına gitmesi */}
          <Route path="*" element={<Navigate to="/authentication/split/login" replace />} />
        </>
      ) : (
        <>
          {/* Giriş yapmış kullanıcılar için korumalı rotalar */}
          <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/support/all-requests/:id" element={<Enterprise />} />
            
            {/* customerId 96 ise Admin Panel'e erişim */}
            {user.customerId === '96' ? (
              <Route path="/admin-panel" element={<AdminPanel />} />
            ) : (
              <Route path="/admin-panel" element={<Navigate to="/errors/404" />} />
            )}
             {/* customerId 96 ise Müşteri Yönetimi'ne erişim */}
            {user.customerId === '96' ? (
              <Route path="/customer-management" element={<Solutions />} />
            ) : (
              <Route path="/customer-management" element={<Navigate to="/errors/404" />} />
            )}

            <Route path="/user/settings" element={<Settings />} />
            <Route path="/user/settings/change-password" element={<ChangePassword/>}/>
          </Route>
          <Route element={<ErrorLayout />}>
            <Route path="errors/404" element={<Error404 />} />
            <Route path="errors/500" element={<Error500 />} />
          </Route>
          <Route path="*" element={<Navigate to="/errors/404" replace />} />
        </>
      )}
    </Routes>
  );
};

export default FalconRoutes;
